export enum RateClassification{
    Residential = 1,
    Commercial = 2,
    Industrial = 3,
    Sewer = 4,
    Water = 5
 }

 export const RateClassificationNames = new Map<number, string>([
    [RateClassification.Residential, 'Residential'],
    [RateClassification.Commercial, 'Commercial'],
    [RateClassification.Industrial, 'Industrial'],
    [RateClassification.Sewer, 'Sewer'],
    [RateClassification.Water, 'Water']
 ])

 export enum RateLoadType {
    Base = 1,
    Demand = 2,
    Surcharge = 3,
    Flat = 4,
    TierBase = 5,
    TierFlat = 6,
    MaxDemand = 7,
    OffPeak = 8,
    OnPeak = 9
 }

 export const RateLoadTypeNames = new Map<number, string>([
    [RateLoadType.Base, 'Base'],
    [RateLoadType.Demand, 'Demand'],
    [RateLoadType.Surcharge, 'Surcharge'],
    [RateLoadType.Flat, 'Flat'],
    [RateLoadType.TierBase, 'Tier Base'],
    [RateLoadType.TierFlat, 'Tier Flat'],
    [RateLoadType.MaxDemand, 'Max Demand'],
    [RateLoadType.OffPeak, 'Off Peak'],
    [RateLoadType.OnPeak, 'On Peak']
 ])